/**
 * The below regex should match the following rtsp/ rtp link
 * rtsp://example.domain.com:1234
 * rtsp://example.domain.com/params
 * rtsp://user:password@example.domain.com:1234/params
 * rtsp://127.0.0.1:1234
 * rtsp://isaac:complexP@$$word@example.domain.com:1234/params
 * rtsp://807e9439d5ca.entrypoint.cloud.wowza.com:1935/app-rC94792j/068b9c9a_stream2
 */
export const RTSP_REGEX =
	/^(rtp)|(rtsp)(:\/\/)([ -~]+:[ -~]+@)?([A-Za-z0-9]+[.]?)+([:][0-9]{2,5})?/;

/**
 * The below regex should match the following rtmp link
 * rtmp://example.domain.com:1234
 * rtmp://example.domain.com/params
 * rtmp://user:password@example.domain.com:1234/params
 * rtmp://127.0.0.1:1234
 * rtmp://isaac:complexP@$$word@example.domain.com:1234/params
 * rtmp://807e9439d5ca.entrypoint.cloud.wowza.com:1935/app-rC94792j/068b9c9a_stream2
 */
export const RTMP_REGEX =
	/^rtmp:\/\/([ -~]+:[ -~]+@)?([A-Za-z0-9]+[.]?)+([:][0-9]{2,5})?(\/[^\s]*)?$/;
/**
 * The below regex should match the following domain
 * cosmos-dev.varadise.cloud
 * google.com
 * xn--diseolatinoamericano-76b.com
 */
export const DOMAIN_NAME_REGEX =
	/^((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,})$/;

/**
 * The below regex should match the following url
 * https://cosmos-dev.varadise.cloud
 * https://google.com
 * http://xn--diseolatinoamericano-76b.com
 */
export const URL_REGEX = new RegExp(
	/^https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?(?![^<]*(?:<\/\w+>|\/?>))/
);

/**
 * The below regex should match the following url
 * https://cosmos-dev.varadise.cloud
 * https://google.com
 * http://xn--diseolatinoamericano-76b.com
 * http://localhost:5173/organizations/65aa39ca-2f82-4378-b8d2-9aa98eed3c4a/projects/list#issue-alert
 * http://localhost:5173/organizations/65aa39ca-2f82-4378-b8d2-9aa98eed3c4a/notification-centre?issueAlertId=682431b5ec1949d545c75f07
 */
export const URL_WITH_PATH_REGEX = /(https?:\/\/[^\s]+)/;

/**
 * The below regex should match the following url
 * https://cosmos-dev.varadi...
 * https://google...
 * http://xn--diseolatinoamerica...
 * http://localhost:5173/organizations/65aa39ca-2f82-...
 * http://localhost:5173/organizations/65aa39ca-2f82-4378-b8d2-9aa98eed3c4a/notification-centre?issueAlertId=682431...
 */
export const URL_WITH_ELLIPSIS_REGEX = /(https?:\/\/[^\s]+\.\.\.)/;

/**
 * The below should match the following number
 * 1
 * +1
 * -1
 * 1.12323
 */
export const NUMBER_REGEX =
	/^[+-]?([1-9]\d*(\.\d*[1-9])?|0\.\d*[1-9]+)|\d+(\.\d*[1-9])$/;

/**
 * The below regex should match the all color format
 * #FFF
 * #FFFFFF
 * rgb(255,255,255)
 * rgba(255,255,255,1)
 * hsl(0, 100%, 100%)
 * hsla(0, 100%, 100%, 100%)
 */
export const COLOR_REGEX =
	/^(#?([a-f\d]{3,4}|[a-f\d]{6}|[a-f\d]{8})|rgb\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d)\)|rgba\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|0?\.\d|1(\.0)?)\)|hsl\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%\)|hsla\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%,(0?\.\d|1(\.0)?)\))$/;

/**
 * The below regex should match the following project code
 * Intentionally to separate max length of 8 characters from regex, such that we can render different error messages
 * abc
 * abc-123
 * abc_123
 * ABC-123
 * A_123
 */
export const PROJECT_CODE_REGEX = /^[a-zA-Z0-9_-]+$/;

/**
 * The below regex should match the following mention tag
 * @{{profileId:99999999-9999-9999-9999-999999999999}}
 * @{{profileId:65aa39ca-2f82-4378-b8d2-9aa98eed3c4a}}
 * @{{profileId:06013def-e3e2-46a9-bc21-6219fa1b52b7}}
 */
export const MENTION_TAG_REGEX =
	/@{{[\w]*:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}}/gm;

/**
 * The below regex should match the following mention tag inner
 * @{{profileId:99999999-9999-9999-9999-999999999999}}
 * @{{profileId:65aa39ca-2f82-4378-b8d2-9aa98eed3c4a}}
 * @{{profileId:06013def-e3e2-46a9-bc21-6219fa1b52b7}}
 */
export const MENTION_TAG_INNER_REGEX =
	/@{{([\w]*):([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})}}/;

/**
 * The below regex should match all dataURI
 */
export const DATA_URI_REGEX = new RegExp(
	/^data:([-\w]+\/[-+\w.]+)?(;?\w+=[-\w]+)*(;base64)?,.*/
);
